module.exports = "/images/stop.svg?41c684bcbbf3a3ae06293f6135a2951e";